import { Suspense, useEffect } from 'react';
import { Box, Paper } from '@mui/material';
import { useValidadorAsientosContablesContext } from '../../../../context/validadorAsientosContablesContext';
import { useNavigate } from 'react-router-dom';
import ResumenFiltrosComponent from '../components/resumenFiltrosComponent';
import ResumenDescuadradosComponent from '../components/resumenDescuadradosComponent';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';


function DetalleDescuadrados() {
    
    const navigate = useNavigate();
    const { formFilters } = useValidadorAsientosContablesContext();

    const breadcrumbItems = [
        { label: 'Contabilidad', url: '/contabilidad' },
        { label: 'Validador de Asientos', url: '/contabilidad/validadorAsientos', state: formFilters },
        { label: 'Analizar movimientos contables', url: '/contabilidad/validadorAsientos/analizarMovimientosContables', state: formFilters },
        { label: 'Asientos descuadrados', active: true, state: formFilters },
    ]
    
    useEffect(() => {
        if( !formFilters ) navigate('/contabilidad/validadorAsientos');
    }, [ formFilters, navigate]);
    
    return (
        <>
            <Suspense>
                <Breadcrumb items={ breadcrumbItems }   />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            { formFilters && (
                                <>
                                    <ResumenFiltrosComponent />
                                    <ResumenDescuadradosComponent />
                                </>
                            ) }
                        </Suspense>
                    </Paper>
                </Box>
            </Suspense>
        </>
    )
}

export default DetalleDescuadrados;